"use strict";
(self["webpackChunkshine_on"] = self["webpackChunkshine_on"] || []).push([[233],{

/***/ 8047:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _node_modules_ps_devs_shopify_webpack_node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5713);
/* harmony import */ var _node_modules_ps_devs_shopify_webpack_node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_ps_devs_shopify_webpack_node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _node_modules_ps_devs_shopify_webpack_node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(103);
/* harmony import */ var _node_modules_ps_devs_shopify_webpack_node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_node_modules_ps_devs_shopify_webpack_node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__);
// Imports


var ___CSS_LOADER_EXPORT___ = _node_modules_ps_devs_shopify_webpack_node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default()((_node_modules_ps_devs_shopify_webpack_node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default()));
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n.copy-code {\n  margin  : auto;\n  position: relative;\n}\n.status-tooltip {\n  padding      : .5rem .5rem;\n  margin       : auto;\n  position     : absolute;\n  top          : -2rem;\n  right        : 0;\n  left         : 0;\n  font-weight  : 500;\n  color        : white;\n  background   : rgba(134, 122, 179, .75);\n  border-radius: 1.5rem;\n}\n", ""]);
// Exports
/* harmony default export */ __webpack_exports__["Z"] = (___CSS_LOADER_EXPORT___);


/***/ }),

/***/ 9863:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _node_modules_ps_devs_shopify_webpack_node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5713);
/* harmony import */ var _node_modules_ps_devs_shopify_webpack_node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_ps_devs_shopify_webpack_node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _node_modules_ps_devs_shopify_webpack_node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(103);
/* harmony import */ var _node_modules_ps_devs_shopify_webpack_node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_node_modules_ps_devs_shopify_webpack_node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__);
// Imports


var ___CSS_LOADER_EXPORT___ = _node_modules_ps_devs_shopify_webpack_node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default()((_node_modules_ps_devs_shopify_webpack_node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default()));
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n*[data-v-1b12723a] {\n  will-change        : height, padding-top, padding-bottom, margin-top, margin-bottom, opacity;\n  transform          : translateZ(0);\n  backface-visibility: hidden;\n  perspective        : 1000px;\n}\n.expand-enter-active[data-v-1b12723a],\n.expand-leave-active[data-v-1b12723a] {\n  transition: height .4s ease-in-out,\n              padding-top .4s ease-in-out,\n              padding-bottom .4s ease-in-out,\n              margin-top .4s ease-in-out,\n              margin-bottom .4s ease-in-out,\n              opacity .2s ease-in-out;\n  overflow  : hidden;\n}\n.expand-enter[data-v-1b12723a],\n.expand-leave-to[data-v-1b12723a] {\n  height        : 0;\n  padding-top   : 0;\n  padding-bottom: 0;\n  margin-top    : 0;\n  margin-bottom : 0;\n  opacity       : 0;\n}\n", ""]);
// Exports
/* harmony default export */ __webpack_exports__["Z"] = (___CSS_LOADER_EXPORT___);


/***/ }),

/***/ 6555:
/***/ (function(__unused_webpack_module, __unused_webpack___webpack_exports__, __webpack_require__) {


// EXTERNAL MODULE: ./node_modules/quicklink/dist/quicklink.mjs
var quicklink = __webpack_require__(933);
// EXTERNAL MODULE: ./node_modules/lazysizes/lazysizes.js
var lazysizes = __webpack_require__(3785);
var lazysizes_default = /*#__PURE__*/__webpack_require__.n(lazysizes);
// EXTERNAL MODULE: ./node_modules/lazysizes/plugins/unveilhooks/ls.unveilhooks.js
var ls_unveilhooks = __webpack_require__(6476);
// EXTERNAL MODULE: ./src/scripts/utils/breakpoints.js
var breakpoints = __webpack_require__(9508);
;// CONCATENATED MODULE: ./src/scripts/utils/lazyloading.js



 // Quicklink

(0,quicklink/* listen */.o)({
  ignores: [/\/logout/, uri => uri.includes('/account'), uri => uri.includes('.zip'), uri => uri.includes('/cart'), (uri, elem) => elem.hasAttribute('noprefetch')]
}); // Lazysizes

(lazysizes_default()).cfg.lazyClass = 'lazyload';
(lazysizes_default()).cfg.customMedia = { ...breakpoints/* mq_breakpoints */.RS
}; // Custom
// Fire event called 'elementinview' for elements with 'lazyscript' class

document.addEventListener('DOMContentLoaded', () => {
  const lazyElements = [].slice.call(document.querySelectorAll('.lazyscript'));

  if ('IntersectionObserver' in window) {
    const options = {
      threshold: 0.1
    };
    const lazyElementObserver = new IntersectionObserver((entries, options) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          const lazyTarget = entry.target;
          const event = new Event('elementinview');
          lazyTarget.dispatchEvent(event);
          lazyElementObserver.unobserve(lazyTarget);
        }
      });
    });
    lazyElements.forEach(el => {
      lazyElementObserver.observe(el);
    });
  } else {
    console.warn('IntersectionObserver not found. Dispatching all events..');
    const lazyElements = [].slice.call(document.querySelectorAll('.lazyscript'));
    lazyElements.forEach(el => {
      const event = new Event('elementinview');
      el.dispatchEvent(event);
    });
  }
}, {
  passive: true
});
// EXTERNAL MODULE: ./src/scripts/vue/main.js + 1 modules
var main = __webpack_require__(3200);
// EXTERNAL MODULE: ./node_modules/vue/dist/vue.min.js
var vue_min = __webpack_require__(9346);
var vue_min_default = /*#__PURE__*/__webpack_require__.n(vue_min);
;// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib/index.js??vue-loader-options!./src/scripts/vue/components/CopyText.vue?vue&type=template&id=ef08b944&
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"copy-code btn--small",attrs:{"aria-label":"copy promo code"},on:{"click":function($event){return _vm.copyPromoCode(_vm.code)}}},[_c('transition',{attrs:{"name":"fade"}},[_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.show),expression:"show"}],staticClass:"status-tooltip",domProps:{"textContent":_vm._s(_vm.text)}})]),_vm._v(" "),_vm._t("default")],2)}
var staticRenderFns = []


;// CONCATENATED MODULE: ./node_modules/babel-loader/lib/index.js!./node_modules/vue-loader/lib/index.js??vue-loader-options!./src/scripts/vue/components/CopyText.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
/* harmony default export */ var CopyTextvue_type_script_lang_js_ = ({
  name: 'CopyText',
  props: ['code'],

  data() {
    return {
      text: '',
      show: false
    };
  },

  methods: {
    copyPromoCode(code) {
      navigator.clipboard.writeText(code).then(() => {
        this.text = 'code copied';
        this.show = true;
      }, () => {
        this.text = 'copy error';
        this.show = true;
      });
      setTimeout(() => {
        this.show = false;
      }, 2000);
    }

  }
});
;// CONCATENATED MODULE: ./src/scripts/vue/components/CopyText.vue?vue&type=script&lang=js&
 /* harmony default export */ var components_CopyTextvue_type_script_lang_js_ = (CopyTextvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./node_modules/style-loader/dist/runtime/injectStylesIntoStyleTag.js
var injectStylesIntoStyleTag = __webpack_require__(3379);
var injectStylesIntoStyleTag_default = /*#__PURE__*/__webpack_require__.n(injectStylesIntoStyleTag);
// EXTERNAL MODULE: ./node_modules/style-loader/dist/runtime/styleDomAPI.js
var styleDomAPI = __webpack_require__(7795);
var styleDomAPI_default = /*#__PURE__*/__webpack_require__.n(styleDomAPI);
// EXTERNAL MODULE: ./node_modules/style-loader/dist/runtime/insertBySelector.js
var insertBySelector = __webpack_require__(569);
var insertBySelector_default = /*#__PURE__*/__webpack_require__.n(insertBySelector);
// EXTERNAL MODULE: ./node_modules/style-loader/dist/runtime/setAttributesWithoutAttributes.js
var setAttributesWithoutAttributes = __webpack_require__(3565);
var setAttributesWithoutAttributes_default = /*#__PURE__*/__webpack_require__.n(setAttributesWithoutAttributes);
// EXTERNAL MODULE: ./node_modules/style-loader/dist/runtime/insertStyleElement.js
var insertStyleElement = __webpack_require__(9216);
var insertStyleElement_default = /*#__PURE__*/__webpack_require__.n(insertStyleElement);
// EXTERNAL MODULE: ./node_modules/style-loader/dist/runtime/styleTagTransform.js
var styleTagTransform = __webpack_require__(4589);
var styleTagTransform_default = /*#__PURE__*/__webpack_require__.n(styleTagTransform);
// EXTERNAL MODULE: ./node_modules/@ps-devs/shopify-webpack/node_modules/css-loader/dist/cjs.js??clonedRuleSet-5[0].rules[0].use[1]!./node_modules/vue-loader/lib/loaders/stylePostLoader.js!./node_modules/vue-loader/lib/index.js??vue-loader-options!./src/scripts/vue/components/CopyText.vue?vue&type=style&index=0&lang=css&
var CopyTextvue_type_style_index_0_lang_css_ = __webpack_require__(8047);
;// CONCATENATED MODULE: ./node_modules/style-loader/dist/cjs.js!./node_modules/@ps-devs/shopify-webpack/node_modules/css-loader/dist/cjs.js??clonedRuleSet-5[0].rules[0].use[1]!./node_modules/vue-loader/lib/loaders/stylePostLoader.js!./node_modules/vue-loader/lib/index.js??vue-loader-options!./src/scripts/vue/components/CopyText.vue?vue&type=style&index=0&lang=css&

      
      
      
      
      
      
      
      
      

var options = {};

options.styleTagTransform = (styleTagTransform_default());
options.setAttributes = (setAttributesWithoutAttributes_default());

      options.insert = insertBySelector_default().bind(null, "head");
    
options.domAPI = (styleDomAPI_default());
options.insertStyleElement = (insertStyleElement_default());

var update = injectStylesIntoStyleTag_default()(CopyTextvue_type_style_index_0_lang_css_/* default */.Z, options);




       /* harmony default export */ var components_CopyTextvue_type_style_index_0_lang_css_ = (CopyTextvue_type_style_index_0_lang_css_/* default */.Z && CopyTextvue_type_style_index_0_lang_css_/* default.locals */.Z.locals ? CopyTextvue_type_style_index_0_lang_css_/* default.locals */.Z.locals : undefined);

;// CONCATENATED MODULE: ./src/scripts/vue/components/CopyText.vue?vue&type=style&index=0&lang=css&

// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(1900);
;// CONCATENATED MODULE: ./src/scripts/vue/components/CopyText.vue



;


/* normalize component */

var component = (0,componentNormalizer/* default */.Z)(
  components_CopyTextvue_type_script_lang_js_,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var CopyText = (component.exports);
;// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib/index.js??vue-loader-options!./src/scripts/vue/components/InstantSearch.vue?vue&type=template&id=42cc3dda&
var InstantSearchvue_type_template_id_42cc3dda_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"instant-search"},[_c('TransitionExpand',[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.search_active),expression:"search_active"}],staticClass:"header-dropdown__search"},[_c('form',{attrs:{"action":"/search","method":"get","role":"search"}},[_c('div',{staticClass:"header-dropdown__search-form"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.query),expression:"query"}],ref:"input",staticClass:"instant-search__input",attrs:{"placeholder":"Search our store","type":"search","name":"q","id":"InstantSearch","autocomplete":"off"},domProps:{"value":(_vm.query)},on:{"keyup":function($event){return _vm.search($event)},"input":function($event){if($event.target.composing){ return; }_vm.query=$event.target.value}}})]),_vm._v(" "),_c('input',{staticStyle:{"height":"0","padding":"0","position":"absolute","border":"0","overflow":"hidden"},attrs:{"type":"submit"}})])])]),_vm._v(" "),(_vm.search_active && _vm.all_empty == false)?_c('div',{staticClass:"instant-search__wrapper"},[_c('div',{staticClass:"instant-search__results"},[(_vm.suggestions.length)?_c('section',{staticClass:"results-group suggestions"},[_vm._m(0),_vm._v(" "),_c('ul',{staticClass:"result-group__ul"},_vm._l((_vm.suggestions),function(suggestion,idx){return _c('li',{key:idx,staticClass:"result-group__li",on:{"click":function($event){return _vm.searchSuggestion(suggestion)}}},[_vm._v("\n            "+_vm._s(suggestion)+"\n          ")])}),0)]):_vm._e(),_vm._v(" "),(_vm.pages.length)?_c('section',{staticClass:"results-group pages"},[_vm._m(1),_vm._v(" "),_c('ul',{staticClass:"result-group__ul"},_vm._l((_vm.pages),function(page,idx){return _c('li',{key:idx,staticClass:"result-group__li"},[_c('a',{attrs:{"href":page.url}},[_vm._v("\n              "+_vm._s(page.title)+"\n            ")])])}),0)]):_vm._e(),_vm._v(" "),(_vm.products.length)?_c('section',{staticClass:"results-group products"},[_vm._m(2),_vm._v(" "),_c('ul',{staticClass:"result-group__ul"},_vm._l((_vm.products),function(product,idx){return _c('li',{key:idx,staticClass:"result-group__li"},[_c('a',{staticClass:"product-item__link result-product",attrs:{"href":("/collections/" + _vm.handle + "/products/" + (product.handle))}},[_c('div',{staticClass:"product-item__image-wrapper"},[_c('VImg',{attrs:{"media":product.images_info[0]}})],1),_vm._v(" "),_c('div',{staticClass:"product-item__details-wrapper"},[_c('span',{staticClass:"product-item__title"},[_vm._v("\n                  "+_vm._s(product.title)+"\n                ")]),_vm._v(" "),_c('p',{staticClass:"product-item__price"},[_vm._v("\n                  $"+_vm._s(product.variants[0].price)+"\n                ")])])])])}),0)]):_vm._e()]),_vm._v(" "),_c('button',{directives:[{name:"show",rawName:"v-show",value:(_vm.products_found),expression:"products_found"}],staticClass:"results-all-products btn--full btn--small",attrs:{"type":"submit"},on:{"click":function($event){return _vm.submitForm()}}},[_vm._v("\n      View All "+_vm._s(_vm.products_found)+" Products\n    ")])]):_vm._e()],1)}
var InstantSearchvue_type_template_id_42cc3dda_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"results-group__header"},[_c('span',[_vm._v("Suggestions")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"results-group__header"},[_c('span',[_vm._v("Pages")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"results-group__header"},[_c('span',[_vm._v("Products")])])}]


;// CONCATENATED MODULE: ./src/scripts/vue/components/InstantSearch.vue?vue&type=template&id=42cc3dda&

// EXTERNAL MODULE: ./src/scripts/vue/components/VImg.vue + 3 modules
var VImg = __webpack_require__(3133);
// EXTERNAL MODULE: ./src/scripts/vue/transitions/TransitionExpand.vue + 5 modules
var TransitionExpand = __webpack_require__(6719);
// EXTERNAL MODULE: ./node_modules/lodash/debounce.js
var debounce = __webpack_require__(9046);
var debounce_default = /*#__PURE__*/__webpack_require__.n(debounce);
;// CONCATENATED MODULE: ./node_modules/babel-loader/lib/index.js!./node_modules/vue-loader/lib/index.js??vue-loader-options!./src/scripts/vue/components/InstantSearch.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var InstantSearchvue_type_script_lang_js_ = ({
  components: {
    VImg: VImg/* default */.Z,
    TransitionExpand: TransitionExpand/* default */.Z
  },
  props: ['terms', 'search_active'],

  data() {
    return {
      query: '',
      suggestions: [],
      pages: [],
      products: [],
      products_found: 0,
      all_empty: true
    };
  },

  watch: {
    search_active: {
      immediate: true,

      handler() {
        if (this.search_active) {
          this.$nextTick(() => {
            this.$refs.input.focus();
          });
        }
      }

    }
  },
  methods: {
    search: debounce_default()(function (e) {
      this.products = []; // Escape

      if (e.key === 'Escape' || e.keyCode === 27) {
        this.query = '';
        this.all_empty = true;
        this.$refs.input.blur();
        this.$parent.toggleSearch();
        return;
      } // Reset


      if (this.query.length < 3) {
        this.all_empty = true;
        return;
      } // BCSF Endpoint


      let url = new URL('https://services.mybcapps.com/bc-sf-filter/search/suggest'); // Request options

      let params = {
        shop: 'shineon-co-nz.myshopify.com',
        q: this.query,
        suggest_types: ['products', 'pages', 'collections'],
        product_limit: 3
      }; // Create query string from params object

      Object.keys(params).forEach(key => {
        url.searchParams.append(key, params[key]);
      }); // Send request

      fetch(url).then(response => response.json()).then(data => {
        this.all_empty = data.all_empty;
        this.suggestions = data.suggestions;
        this.pages = data.pages;
        this.collections = data.collections;
        this.products = data.products;
        this.products_found = data.total_product;
      }).catch(error => {
        console.log('error', error);
      });
    }, 100),

    searchSuggestion(suggestion) {
      this.query = suggestion;
      this.$refs.input.value = suggestion;
      this.$parent.$el.querySelector('form[action="/search"]').submit();
    },

    submitForm() {
      this.$parent.$el.querySelector('form[action="/search"]').submit();
    }

  }
});
;// CONCATENATED MODULE: ./src/scripts/vue/components/InstantSearch.vue?vue&type=script&lang=js&
 /* harmony default export */ var components_InstantSearchvue_type_script_lang_js_ = (InstantSearchvue_type_script_lang_js_); 
;// CONCATENATED MODULE: ./src/scripts/vue/components/InstantSearch.vue





/* normalize component */
;
var InstantSearch_component = (0,componentNormalizer/* default */.Z)(
  components_InstantSearchvue_type_script_lang_js_,
  InstantSearchvue_type_template_id_42cc3dda_render,
  InstantSearchvue_type_template_id_42cc3dda_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var InstantSearch = (InstantSearch_component.exports);
// EXTERNAL MODULE: ./node_modules/lodash-es/throttle.js + 14 modules
var throttle = __webpack_require__(5325);
;// CONCATENATED MODULE: ./src/scripts/sections/header.js





let annoucementBarWaypoint = 75;
window.PSTheme.Vue.Header = new (vue_min_default())({
  name: 'Header',
  components: {
    CopyText: CopyText,
    InstantSearch: InstantSearch
  },
  data: {
    cartCount: 0,
    secondMenuIdx: null,
    thirdMenuIdx: null
  },

  mounted() {
    this.cartCount = this.$refs.cart_count.dataset.count || 0;

    if (window.PSTheme.Settings.Outlet === false) {
      let wishlist_btn = document.createComment(` include 'wishlist-link' `);
      this.$refs['insert-wishlist'].appendChild(wishlist_btn);
    }
  },

  methods: {
    openMenu() {
      this.secondMenuIdx = null;
      this.thirdMenuIdx = null;
      this.$actions.openMenu();
    },

    toggleMenu() {
      this.secondMenuIdx = null;
      this.thirdMenuIdx = null;
      this.$actions.toggleMenu();
    },

    toggleSecondMenu(secondMenuKey) {
      if (this.$store.menuActive == false) {
        this.$actions.openMenu();
      }

      if (this.secondMenuIdx !== secondMenuKey) {
        this.secondMenuIdx = secondMenuKey;
      } else {
        this.secondMenuIdx = null;

        if (window.matchMedia(breakpoints/* mq_breakpoints.--tablet-lg-up */.RS["--tablet-lg-up"]).matches) {
          this.toggleMenu();
        }
      }

      this.thirdMenuIdx = null;
    },

    toggleThirdMenu(thirdMenuKey, secondMenuLink) {
      if (this.thirdMenuIdx !== thirdMenuKey) {
        this.thirdMenuIdx = thirdMenuKey;
      } else {
        this.thirdMenuIdx = null;
      }
    },

    toggleSearch() {
      this.$actions.toggleSearch();
    },

    toggleNotifications() {
      this.$actions.toggleNotifications();
    },

    closeAnnouncementOnScroll: (0,throttle/* default */.Z)(function () {
      this.$store.closeAnnouncement = window.pageYOffset >= annoucementBarWaypoint;
    }, 250),

    updateCartCount(amount) {
      this.cartCount = Number(this.cartCount) + amount;
    },

    setCartCount(cart_count) {
      this.cartCount = cart_count;
    }

  }
}).$mount('.app__header');
;// CONCATENATED MODULE: ./src/scripts/sections/footer.js


window.PSTheme.Vue.Footer = new (vue_min_default())({
  name: 'Footer',
  components: {
    TransitionExpand: TransitionExpand/* default */.Z
  },
  data: {
    footerMenuIdx: null
  },
  methods: {
    toggleFooterMenu(loopIdx) {
      if (loopIdx == this.footerMenuIdx) {
        this.footerMenuIdx = null;
      } else {
        this.footerMenuIdx = loopIdx;
      }
    }

  }
}).$mount('.app__footer');
// EXTERNAL MODULE: ./node_modules/local-storage/local-storage.js
var local_storage = __webpack_require__(9982);
var local_storage_default = /*#__PURE__*/__webpack_require__.n(local_storage);
;// CONCATENATED MODULE: ./src/scripts/sections/popup-banner.js


window.PSTheme.Vue.PopupBanner = new (vue_min_default())({
  name: 'PopupBanner',

  data() {
    return {
      showPopup: !local_storage_default()('PSPopupBannerViewed')
    };
  },

  methods: {
    setPopupBannerViewed() {
      this.showPopup = false;
      local_storage_default()('PSPopupBannerViewed', true);
    }

  },

  mounted() {
    window.onload = function () {
      const popupClose = document.getElementById('lpclose');

      if (popupClose) {
        popupClose.addEventListener('click', event => {
          const el = document.getElementById('_lpSurveyPopover');

          if (el.classList.contains('block')) {
            el.classList.remove('block');
          }
        });
      } // Select element with box class, assign to box variable
      // Detect all clicks on the document


      const box = document.getElementById('_lpSurveyPopover');

      if (box) {
        document.addEventListener('click', event => {
          // If user clicks inside the element, do nothing
          if (event.target.closest('#_lpSurveyPopover')) {
            if (box.classList.contains('block')) {
              box.classList.remove('block');
            }
          }
        });
      }
    };
  }

}).$mount('.app__popup-banner');
;// CONCATENATED MODULE: ./src/scripts/layout/theme.js
/* styles */

/* utils */



/* vue */


/* global */





/***/ }),

/***/ 9508:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "RS": function() { return /* binding */ mq_breakpoints; },
/* harmony export */   "ku": function() { return /* binding */ px_breakpoints; }
/* harmony export */ });
/* unused harmony export px_queries */
// EMs
let mq_breakpoints = {
  '--mobile-down': '(max-width: 25.99em)',
  '--mobile-up': '(min-width: 26em)',
  '--phablet-down': '(min-width: 32.49em)',
  '--phablet-up': '(min-width: 32.5em)',
  '--tablet-down': '(max-width: 39.99em)',
  '--tablet-up': '(min-width: 40em)',
  '--tablet-lg-down': '(min-width: 63.99em)',
  '--tablet-lg-up': '(min-width: 64em)',
  '--laptop-down': '(max-width: 71.99em)',
  '--laptop-up': '(min-width: 72em)',
  '--desktop-down': '(max-width: 99.99em)',
  '--desktop-up': '(min-width: 100em)',
  '--ultrawide': '(min-width: 125em)'
}; // Pixels

let px_breakpoints = {
  '--mobile-up': 416,
  '--phablet-up': 520,
  '--tablet-up': 640,
  '--tablet-lg-up': 1024,
  '--laptop-up': 1152,
  '--desktop-up': 1600,
  '--ultrawide': 2000
};
let px_queries = {
  '--mobile-up': '(min-width: 416px)',
  '--phablet-up': '(min-width: 520px)',
  '--tablet-up': '(min-width: 640px)',
  '--tablet-lg-up': '(min-width: 1024px)',
  '--laptop-up': '(min-width: 1152px)',
  '--desktop-up': '(min-width: 1600px)',
  '--ultrawide': '(min-width: 2000px)'
};


/***/ }),

/***/ 3200:
/***/ (function(__unused_webpack_module, __unused_webpack___webpack_exports__, __webpack_require__) {


// EXTERNAL MODULE: ./node_modules/vue/dist/vue.min.js
var vue_min = __webpack_require__(9346);
var vue_min_default = /*#__PURE__*/__webpack_require__.n(vue_min);
;// CONCATENATED MODULE: ./src/scripts/vue/store/global.js

const store = vue_min_default().observable({
  menuActive: false,
  searchActive: false,
  notificationsActive: false,
  closeAnnouncement: false,
  customerCountry: 'NZ'
});
const actions = {
  openMenu() {
    store.menuActive = true;
  },

  toggleMenu() {
    if (store.menuActive) {
      this.closeAll();
    } else {
      this.closeAll();
      store.menuActive = true;
    }
  },

  toggleSearch() {
    store.searchActive = !store.searchActive;
  },

  toggleNotifications() {
    store.notificationsActive = !store.notificationsActive;
  },

  closeAll() {
    store.menuActive = false;
    store.searchActive = false;
    store.notificationsActive = false;
    window.PSTheme.Vue.Header.secondMenuIdx = null;
    window.PSTheme.Vue.Header.thirdMenuIdx = null;
  }

};
(vue_min_default()).prototype.$store = store;
(vue_min_default()).prototype.$actions = actions;
// EXTERNAL MODULE: ./src/scripts/utils/breakpoints.js
var breakpoints = __webpack_require__(9508);
// EXTERNAL MODULE: ./node_modules/@vue/composition-api/dist/vue-composition-api.mjs
var vue_composition_api = __webpack_require__(5706);
// EXTERNAL MODULE: ./node_modules/vue-screen/dist/vue-screen.esm.js
var vue_screen_esm = __webpack_require__(6768);
// EXTERNAL MODULE: ./node_modules/@shopify/theme-currency/currency.js
var currency = __webpack_require__(1186);
// EXTERNAL MODULE: ./node_modules/@shopify/theme-images/images.js
var theme_images_images = __webpack_require__(3253);
;// CONCATENATED MODULE: ./src/scripts/vue/main.js







/* config */

(vue_min_default()).config.devtools = true;
(vue_min_default()).config.productionTip = false;
(vue_min_default()).config.silent = true;
/* extensions */

(vue_min_default()).prototype.$language = globalThis.PSTheme.Language;
(vue_min_default()).prototype.$settings = globalThis.PSTheme.Settings;
(vue_min_default()).prototype.$customer = globalThis.PSTheme.Customer;

(vue_min_default()).prototype.$image = (src, size = '750x') => theme_images_images/* getSizedImageUrl */.M0(src, size);

(vue_min_default()).prototype.$preloadImages = (imgArray, size = '750x') => theme_images_images/* preload */.MA(imgArray, size);

(vue_min_default()).prototype.$money = amount => (0,currency/* formatMoney */.l)(amount, '${{amount}}');

(vue_min_default()).prototype.$isEmpty = obj => {
  if (obj && Object.keys(obj).length === 0 && obj.constructor === Object) return true;
};
/* plugins */


vue_min_default().use(vue_composition_api/* default */.ZP);
vue_min_default().use(vue_screen_esm/* default */.Z, {
  mobile_up: breakpoints/* px_breakpoints.--mobile-up */.ku["--mobile-up"],
  tablet_up: breakpoints/* px_breakpoints.--tablet-up */.ku["--tablet-up"],
  tablet_lg_up: breakpoints/* px_breakpoints.--tablet-lg-up */.ku["--tablet-lg-up"],
  laptop_up: breakpoints/* px_breakpoints.--laptop-up */.ku["--laptop-up"],
  desktop_up: breakpoints/* px_breakpoints.--desktop-up */.ku["--desktop-up"]
});

/***/ }),

/***/ 3133:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ VImg; }
});

;// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib/index.js??vue-loader-options!./src/scripts/vue/components/VImg.vue?vue&type=template&id=4a5ed573&
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('img',{staticClass:"vimg",class:_vm.customClass,attrs:{"src":_vm.fixedSize ? _vm.$image(_vm.media.src, _vm.fixedSize) : _vm.$image(_vm.media.src),"srcset":_vm.fixedSize ? '' : _vm.srcset,"data-sizes":"auto","alt":_vm.media.alt || _vm.$attrs.alt || 'Image',"loading":_vm.loading_method || 'lazy'}})}
var staticRenderFns = []


;// CONCATENATED MODULE: ./node_modules/babel-loader/lib/index.js!./node_modules/vue-loader/lib/index.js??vue-loader-options!./src/scripts/vue/components/VImg.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
/* harmony default export */ var VImgvue_type_script_lang_js_ = ({
  name: 'VImg',
  props: ['media', 'fixedSize', 'customClass', 'loading_method'],
  computed: {
    srcset() {
      if (this.fixedSize) return null;
      const {
        src,
        width
      } = this.media;
      const srcset = `${this.$image(src, '200x')} 100w'
      ${width >= 200 ? `, ${this.$image(src, '400x')} 200w` : ''}
      ${width >= 400 ? `, ${this.$image(src, '800x')} 400w` : ''}
      ${width >= 600 ? `, ${this.$image(src, '1200x')} 600w` : ''}
      ${width >= 800 ? `, ${this.$image(src, '1600x')} 800w` : ''}
      ${width >= 1000 ? `, ${this.$image(src, '2000x')} 1000w` : ''}
      ${width >= 1500 ? `, ${this.$image(src, '3000x')} 1500w` : ''}
      ${width >= 2000 ? `, ${this.$image(src, '4000x')} 2000w` : ''}`;
      return srcset;
    }

  }
});
;// CONCATENATED MODULE: ./src/scripts/vue/components/VImg.vue?vue&type=script&lang=js&
 /* harmony default export */ var components_VImgvue_type_script_lang_js_ = (VImgvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(1900);
;// CONCATENATED MODULE: ./src/scripts/vue/components/VImg.vue





/* normalize component */
;
var component = (0,componentNormalizer/* default */.Z)(
  components_VImgvue_type_script_lang_js_,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var VImg = (component.exports);

/***/ }),

/***/ 6719:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ TransitionExpand; }
});

;// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib/index.js??vue-loader-options!./src/scripts/vue/transitions/TransitionExpand.vue?vue&type=template&id=1b12723a&scoped=true&
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"expand"},on:{"enter":_vm.enter,"after-enter":_vm.afterEnter,"leave":_vm.leave}},[_vm._t("default")],2)}
var staticRenderFns = []


;// CONCATENATED MODULE: ./node_modules/babel-loader/lib/index.js!./node_modules/vue-loader/lib/index.js??vue-loader-options!./src/scripts/vue/transitions/TransitionExpand.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
/* harmony default export */ var TransitionExpandvue_type_script_lang_js_ = ({
  name: 'TransitionExpand',
  props: {
    fixedEntryHeight: {
      type: String,
      required: false,
      default: null
    },
    linear_padding: {
      type: String,
      required: false,
      default: ''
    },
    linear_margin: {
      type: String,
      required: false,
      default: ''
    }
  },
  methods: {
    enter(element) {
      element.style.height = this.fixedEntryHeight || element.scrollHeight + 'px';
      element.style.opacity = 1;

      if (this.linear_padding !== '') {
        element.style.paddingTop = this.linear_padding;
        element.style.paddingBottom = this.linear_padding;
      }

      if (this.linear_margin !== '') {
        element.style.marginTop = this.linear_margin;
        element.style.marginBottom = this.linear_margin;
      }
    },

    afterEnter(element) {
      element.style.height = 'auto';
    },

    leave(element) {
      element.style.height = element.scrollHeight + 'px';
      setTimeout(() => {
        element.style.height = 0;
        element.style.opacity = 0;

        if (this.linear_padding !== '') {
          element.style.paddingTop = 0;
          element.style.paddingBottom = 0;
        }

        if (this.linear_margin !== '') {
          element.style.marginTop = 0;
          element.style.marginBottom = 0;
        }
      }, 50);
    }

  }
});
;// CONCATENATED MODULE: ./src/scripts/vue/transitions/TransitionExpand.vue?vue&type=script&lang=js&
 /* harmony default export */ var transitions_TransitionExpandvue_type_script_lang_js_ = (TransitionExpandvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./node_modules/style-loader/dist/runtime/injectStylesIntoStyleTag.js
var injectStylesIntoStyleTag = __webpack_require__(3379);
var injectStylesIntoStyleTag_default = /*#__PURE__*/__webpack_require__.n(injectStylesIntoStyleTag);
// EXTERNAL MODULE: ./node_modules/style-loader/dist/runtime/styleDomAPI.js
var styleDomAPI = __webpack_require__(7795);
var styleDomAPI_default = /*#__PURE__*/__webpack_require__.n(styleDomAPI);
// EXTERNAL MODULE: ./node_modules/style-loader/dist/runtime/insertBySelector.js
var insertBySelector = __webpack_require__(569);
var insertBySelector_default = /*#__PURE__*/__webpack_require__.n(insertBySelector);
// EXTERNAL MODULE: ./node_modules/style-loader/dist/runtime/setAttributesWithoutAttributes.js
var setAttributesWithoutAttributes = __webpack_require__(3565);
var setAttributesWithoutAttributes_default = /*#__PURE__*/__webpack_require__.n(setAttributesWithoutAttributes);
// EXTERNAL MODULE: ./node_modules/style-loader/dist/runtime/insertStyleElement.js
var insertStyleElement = __webpack_require__(9216);
var insertStyleElement_default = /*#__PURE__*/__webpack_require__.n(insertStyleElement);
// EXTERNAL MODULE: ./node_modules/style-loader/dist/runtime/styleTagTransform.js
var styleTagTransform = __webpack_require__(4589);
var styleTagTransform_default = /*#__PURE__*/__webpack_require__.n(styleTagTransform);
// EXTERNAL MODULE: ./node_modules/@ps-devs/shopify-webpack/node_modules/css-loader/dist/cjs.js??clonedRuleSet-5[0].rules[0].use[1]!./node_modules/vue-loader/lib/loaders/stylePostLoader.js!./node_modules/vue-loader/lib/index.js??vue-loader-options!./src/scripts/vue/transitions/TransitionExpand.vue?vue&type=style&index=0&id=1b12723a&scoped=true&lang=css&
var TransitionExpandvue_type_style_index_0_id_1b12723a_scoped_true_lang_css_ = __webpack_require__(9863);
;// CONCATENATED MODULE: ./node_modules/style-loader/dist/cjs.js!./node_modules/@ps-devs/shopify-webpack/node_modules/css-loader/dist/cjs.js??clonedRuleSet-5[0].rules[0].use[1]!./node_modules/vue-loader/lib/loaders/stylePostLoader.js!./node_modules/vue-loader/lib/index.js??vue-loader-options!./src/scripts/vue/transitions/TransitionExpand.vue?vue&type=style&index=0&id=1b12723a&scoped=true&lang=css&

      
      
      
      
      
      
      
      
      

var options = {};

options.styleTagTransform = (styleTagTransform_default());
options.setAttributes = (setAttributesWithoutAttributes_default());

      options.insert = insertBySelector_default().bind(null, "head");
    
options.domAPI = (styleDomAPI_default());
options.insertStyleElement = (insertStyleElement_default());

var update = injectStylesIntoStyleTag_default()(TransitionExpandvue_type_style_index_0_id_1b12723a_scoped_true_lang_css_/* default */.Z, options);




       /* harmony default export */ var transitions_TransitionExpandvue_type_style_index_0_id_1b12723a_scoped_true_lang_css_ = (TransitionExpandvue_type_style_index_0_id_1b12723a_scoped_true_lang_css_/* default */.Z && TransitionExpandvue_type_style_index_0_id_1b12723a_scoped_true_lang_css_/* default.locals */.Z.locals ? TransitionExpandvue_type_style_index_0_id_1b12723a_scoped_true_lang_css_/* default.locals */.Z.locals : undefined);

;// CONCATENATED MODULE: ./src/scripts/vue/transitions/TransitionExpand.vue?vue&type=style&index=0&id=1b12723a&scoped=true&lang=css&

// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(1900);
;// CONCATENATED MODULE: ./src/scripts/vue/transitions/TransitionExpand.vue



;


/* normalize component */

var component = (0,componentNormalizer/* default */.Z)(
  transitions_TransitionExpandvue_type_script_lang_js_,
  render,
  staticRenderFns,
  false,
  null,
  "1b12723a",
  null
  
)

/* harmony default export */ var TransitionExpand = (component.exports);

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [346,383,539,609], function() { return __webpack_exec__(6555); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ }
]);